import {Injectable} from "@angular/core";
import {EvkExpedienteConfigModel} from "../models/evk-expediente-config.model";
import {EvkExpedienteModel} from "../models/evk-expediente.model";
import {forkJoin, Subject} from "rxjs";
import {map, pluck, take, takeUntil} from "rxjs/operators";
import {EvkHttpService} from "@evomatik/evk-common";

@Injectable({providedIn: 'root'})
export class WizardExpedientesService {

    private expedienteConfig: EvkExpedienteConfigModel;
    private expediente: EvkExpedienteModel;

    private _unsubscribeAll = new Subject();

    private getExpedienteAndConfig$: Subject<{
        expedienteConfig: EvkExpedienteConfigModel,
        expediente: EvkExpedienteModel
    }> = new Subject<{ expedienteConfig: EvkExpedienteConfigModel; expediente: EvkExpedienteModel; }>();

    public getExpedienteAndConfig = this.getExpedienteAndConfig$.asObservable().pipe(takeUntil(this._unsubscribeAll), map(value => {
        this.expedienteConfig = value.expedienteConfig;
        this.expediente = value.expediente;
        return value;
    }))

    constructor(
        public http: EvkHttpService
    ) {
    }

    getExpedienteConfigAndExpediente(idExpedienteConfig?: string, idExpediente?: any) {
        let joinObjMap = {};

        if (idExpedienteConfig && idExpediente) {
            joinObjMap = {
                expedienteConfig: this.http.get(`/seaged-expedientes-service/configuracion-expediente/${idExpedienteConfig}`).pipe(pluck('data')),
                expediente: this.http.get(`/seaged-expedientes-service/expediente/${idExpediente}`).pipe(pluck('data'), take(1))
            };
        }

        if (idExpedienteConfig && !idExpediente) {
            joinObjMap = {
                expedienteConfig: this.http.get(`/seaged-expedientes-service/configuracion-expediente/${idExpedienteConfig}`).pipe(pluck('data'))
            };
        }

        forkJoin(
            joinObjMap
        ).pipe(take(1)).subscribe(response => this.getExpedienteAndConfig$.next({
            expediente: response['expediente'],
            expedienteConfig: response['expedienteConfig']
        }));

    }

    updateData(expediente: EvkExpedienteModel) {
        this.getExpedienteAndConfig$.next({
            expedienteConfig: this.expedienteConfig,
            expediente: expediente,
        });
    }

    public stopSubscriptions() {
        this._unsubscribeAll.next();
    }


    /**
     * 
     * @param index 
     * @returns 
     */
    getPaso(index: number): any | undefined {
        const secciones = this.expediente?.secciones;
        if (secciones && secciones.length > 0 && secciones[index]) {
            return secciones[index].propiedades;
        }
        return undefined;
    }
    
    /**
     * 
     * @returns 
     */
    puedoIngresarFolio(): boolean{
        let result = false;
        if(this.expediente && this.expediente.estados){
            const estadoActivo = this.expediente.estados.find((e) => { return e.activo;});
            result =  estadoActivo && estadoActivo.estado.nombre == "Iniciado";
        }
        return result;
    }


  

    /**
     * 
     * @param expediente 
     * @returns 
     */
    validarFolio(expediente: EvkExpedienteModel) {
        if (expediente.folio && expediente.folio != '') {
            return expediente.folio;
        } else {
            return expediente.folioProvisional;
        }

    }

    /**
     * Valida y obtiene el nombre de la persona desaparecida del expediente
     * @param expediente 
     * @returns 
     */
    validarNombrePersona(expediente: EvkExpedienteModel): string {
        if(expediente && expediente.secciones && expediente.secciones.length > 0){
            let seccionInfoReporte = expediente.secciones.find((e) => {return e.origen === "personaDesaparecida"});
            if(seccionInfoReporte && seccionInfoReporte.propiedades
                && seccionInfoReporte.propiedades.datosPersonaDesaparecida){
                const { nombre, primerApellido, segundoApellido } = seccionInfoReporte.propiedades.datosPersonaDesaparecida;
                return `${nombre ? nombre : ''} ${primerApellido ? primerApellido : ''} ${segundoApellido ? segundoApellido : ''}`;
            }
        }
        return "";
    }

    /**
     * 
     * @param row 
     * @returns 
     */
    validarActualizar(row: EvkExpedienteModel): boolean {
        return row.configuracionExpediente.actualizar != null && row.configuracionExpediente.actualizar.length > 0;
    }  

}
